var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHibernateIconWhitebkg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#59666C",
    points: "103.4,85.268 54.151,170.661 54.151,170.661 4.94,85.269 54.17,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BCAE79",
    points: "152.66,0.003 54.198,0.003 103.43,85.272 201.916,85.269  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#59666C",
    points: "152.633,170.703 201.88,85.309 201.88,85.309 251.092,170.703 201.861,255.971  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BCAE79",
    points: "103.374,255.968 201.835,255.968 152.604,170.697 54.117,170.703  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHibernateIconWhitebkg);
export default __webpack_public_path__ + "static/media/hibernate_icon_whitebkg.f0b345beb75257ef88f5d597d97e77ca.svg";
export { ForwardRef as ReactComponent };